import React from "react";
import OrdemTipoService from "../../services/OrdemTipoService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaOrdemTipo extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: OrdemTipoService,
            labels: {
                title: 'Lista de Tipo(s) de Ordem(s)',
                btnNewRegister: 'Tipo de Ordem',
            },
            keyItem: 'idOrdemTipo',
            urlForm: '/CadOrdemTipo',
            itensFilter: ["idOrdemTipo", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-10"> Nome </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idOrdemTipo}</td>
                <td>{item.nome}</td>
            </>);
    }

    render() {
        return super.render();
    }
}